import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { GoogleReviewsBadge } from './GoogleReviewsBadge';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center pt-20 pb-32 md:pb-40 bg-primary overflow-hidden" data-id="element-135">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-136">
        <div className="absolute inset-0 bg-primary/40 z-10" data-id="element-137"></div>
        <img src="https://cdn.magicpatterns.com/uploads/2Mh9wUuAnyoi4AHhEaSFM2/pexels-artbovich-6970056.jpg" alt="Dark minimalist interior with pendant lights" className="w-full h-full object-cover" data-id="element-138" />
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-30 pt-20 w-full" data-id="element-139">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12 lg:gap-8" data-id="element-140">
          <div className="max-w-4xl" data-id="element-141">
            <motion.h1 initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="text-white text-5xl md:text-7xl lg:text-8xl font-heading font-bold uppercase leading-[0.9] tracking-tight" data-id="element-142">
              We Shine, <br data-id="element-143" />
              When You{' '}
              <span className="font-script text-white lowercase tracking-normal text-6xl md:text-8xl lg:text-9xl ml-2 font-normal" data-id="element-144">
                Shine!
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="mt-8 text-lg md:text-xl max-w-md font-light leading-relaxed" data-id="element-145">
              <span className="inline-block bg-accent/25 backdrop-blur-sm text-white px-4 py-3 rounded-lg border border-accent/20" data-id="element-146">
                No residential, commercial
                <br data-id="element-147" />
                nor spring/deep clean
                <br data-id="element-148" />
                is too big or too small.
              </span>
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} className="mt-12" data-id="element-149">
              <Link to="/services" className="inline-flex items-center gap-2 bg-accent hover:bg-accent/85 text-white font-sans font-bold text-lg tracking-wide px-8 py-4 rounded-lg shadow-lg shadow-accent/30 hover:shadow-accent/50 transition-all duration-300 hover:scale-105" data-id="element-150">
                Book online
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-151">
                  <path d="M5 12h14" data-id="element-152" />
                  <path d="m12 5 7 7-7 7" data-id="element-153" />
                </svg>
              </Link>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="pb-4 lg:pb-8 self-start lg:self-end" data-id="element-154">
            <GoogleReviewsBadge variant="light" size="md" data-id="element-155" />
          </motion.div>
        </div>
      </div>
    </section>;
}